export default __webpack_public_path__ + "static/media/tableau.7b29e214.svg";